import styled from "styled-components";

export const StyledPaymentHeader = styled.div<{
    $isCompleted: boolean;
    $isExported: boolean;
}>`
    position: relative;
    &::before {
        display: ${({ $isCompleted, $isExported }) =>
            !$isCompleted || !$isExported ? "block" : "none"};
        content: "";
        position: absolute;
        top: 0;
        left: -40px;
        width: 5px;
        height: 100%;
        background-color: ${({ theme, $isCompleted }) =>
            !$isCompleted ? theme.dangerTypographyColor : theme.colors.warning};
    }
`;

export const StyledComment = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.itemBackground};
    padding: 8px 12px;
    font-size: 12px;
    color: ${({ theme }) => theme.secondaryTypographyColor};
`;
